import { receivableInvoicesApiNamespace } from 'receivable-invoices-js/constants/hosts';
import { qontoClient } from 'receivable-invoices-js/react/utils/api-clients/qonto';
import { fetchClientPortalSettings } from './fetch-client-portal-settings';

vi.mock('@repo/design-system-kit', () => ({
  useToast: vi.fn(() => ({
    showToast: vi.fn(),
  })),
}));

vi.mock('receivable-invoices-js/react/utils/api-clients/qonto');
vi.mock('receivable-invoices-js/constants/hosts', () => ({
  receivableInvoicesApiNamespace: '/api/v5',
}));

describe('unit | API | queries | fetch-client-portal-settings', () => {
  const mockQontoClient = vi.mocked(qontoClient);
  const clientId = 'client-123';
  const URL = `${receivableInvoicesApiNamespace}/receivable_invoices/client_portals/shared`;

  beforeEach(() => {
    vi.clearAllMocks();
  });

  describe(fetchClientPortalSettings, () => {
    it('fetches client portal settings successfully', async () => {
      const apiResponse = {
        data: {
          type: 'client_portals',
          id: 'client-123',
          attributes: {
            client_portal_enabled: true,
          },
        },
      };

      mockQontoClient.mockResolvedValue(apiResponse);

      const result = await fetchClientPortalSettings({ clientId }, {});

      expect(mockQontoClient).toHaveBeenCalledWith(`${URL}/${clientId}/settings`);
      expect(result).toStrictEqual({
        id: 'client-123',
        clientPortalEnabled: true,
      });
    });

    it('handles API errors with custom error handler', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      const onError = vi.fn<(err: unknown) => void>();
      await fetchClientPortalSettings({ clientId }, { onError });

      expect(onError).toHaveBeenCalledWith(error);
    });

    it('throws error when no error handler is provided', async () => {
      const error = new Error('API Error');
      mockQontoClient.mockRejectedValue(error);

      await expect(fetchClientPortalSettings({ clientId }, {})).rejects.toThrow('API Error');
    });
  });
});
